import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getContactDisplayName, getPreferredContactName } from 'shared/utils/get_contact_display_name';
import { getInitials } from 'shared/utils/get_initials';
const containerCss = "c1m2hh5x";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const columnCss = "c1hrx1te";
const Column = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(columnCss, props.className)} />;
});
export const ContactItem = ({
  contact
}) => {
  const preferredName = getPreferredContactName(contact);
  const displayName = getContactDisplayName(contact);
  return <Container>
      {preferredName && <FullStoryExclude>
          <Avatar src={contact.previewUrl} letter={getInitials(preferredName)} size="small" />
        </FullStoryExclude>}
      <Column>
        <BodyText><FullStoryMask>{displayName}</FullStoryMask></BodyText>
        {!!preferredName && !!contact.email && <BodyText color="muted" size="medium"><FullStoryMask>{contact.email}</FullStoryMask></BodyText>}
      </Column>
    </Container>;
};

require("./contact_item.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_item.js");